// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ChipsModule } from 'primeng/chips';

// Afidium
import { SearchSummaryComponent } from './search-summary.component';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { CardFormModule } from 'libraries/module/formbuilder/forms/card-form/card-form.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { LabelModule } from "../../service/label/label.module";
import { MatChipsModule } from "@angular/material/chips";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { GetLabelPipe } from "./get-label.pipe";

@NgModule({
    imports: [
        ButtonModule,
        CardFormModule,
        CardModule,
        ChipsModule,
        CommonModule,
        FormsModule,
        LabelModule,
        NotificationModule,
        MatChipsModule,
        FontAwesomeModule,
    ],
    declarations: [
        SearchSummaryComponent,
        GetLabelPipe,
    ],
    exports: [
        SearchSummaryComponent,
    ]
})
export class SearchSummaryModule {
}
